import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useParams, useLocation } from "react-router-dom";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import EnquiryNow from "../common/EnquiryNow";
import Allinone from "../common/Allinone";
import Brochure from "../../Images/Brochure/ISBM_PROSPECTUS.pdf";
import { Row, Modal } from "react-bootstrap";

const CourseDetails = () => {
  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [show, setShow] = useState(false);

  const { courseName } = useParams();
  const location = useLocation();

  const [course, setCourse] = useState(null);
  const [schoolName, setSchoolName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [courseList, setCourseList] = useState([]);
  const [careerList, setCareerList] = useState([]);

  const handleClose = () => setShow(false);

  // Scroll top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Fetch course
  useEffect(() => {
    const fetchCourseDetails = async () => {
      try {
        setLoading(true);

        const response = await axios.get(
          `https://isbmuniversity.edu.in/admin-portal/courses/${courseName}`,
        );

        const courseData = response.data.data[0];

        setCourse(courseData);
        setSchoolName(courseData.school_name);
      } catch (err) {
        setError("Error fetching course details");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCourseDetails();
  }, [courseName]);

  // Fetch course list
  useEffect(() => {
    if (!schoolName) return;

    const fetchCourseList = async () => {
      try {
        const response = await axios.get(
          `https://isbmuniversity.edu.in/admin-portal/coursesList/${schoolName}`,
        );

        setCourseList(response.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCourseList();
  }, [schoolName]);

  // Fetch career list
  useEffect(() => {
    if (!schoolName) return;

    const fetchCareerList = async () => {
      try {
        const response = await axios.get(
          `https://isbmuniversity.edu.in/admin-portal/career_opportunity/${schoolName}`,
        );

        setCareerList(response.data.careers);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCareerList();
  }, [schoolName]);

  // SEO + META + SCHEMA
  useEffect(() => {
    if (!course) return;

    document.title = course.metatitle || "ISBM University";

    const setMetaTag = (name, content, property = false) => {
      const selector = property
        ? `meta[property="${name}"]`
        : `meta[name="${name}"]`;

      let tag = document.head.querySelector(selector);

      if (!tag) {
        tag = document.createElement("meta");

        if (property) {
          tag.setAttribute("property", name);
        } else {
          tag.setAttribute("name", name);
        }

        document.head.appendChild(tag);
      }

      tag.setAttribute("content", content || "");
    };

    // Basic SEO
    setMetaTag("description", course.metadesc);
    setMetaTag("keywords", course.keywords);
    setMetaTag("robots", "index, follow");
    setMetaTag("author", "ISBM University");
    setMetaTag("language", "English");

    // Open Graph
    setMetaTag("og:title", course.metatitle, true);
    setMetaTag("og:description", course.metadesc, true);
    setMetaTag(
      "og:url",
      `https://isbmuniversity.edu.in/course-details/${course.name}`,
      true,
    );
    setMetaTag(
      "og:image",
      "https://isbmuniversity.edu.in/static/media/commb.0f9333e0.webp",
      true,
    );
    setMetaTag("og:type", "website", true);
    setMetaTag("og:site_name", "ISBM University", true);

    // Twitter
    setMetaTag("twitter:card", "summary_large_image");
    setMetaTag("twitter:title", course.metatitle);
    setMetaTag("twitter:description", course.metadesc);
    setMetaTag(
      "twitter:image",
      "https://isbmuniversity.edu.in/static/media/commb.0f9333e0.webp",
    );

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');

    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }

    canonical.href = `https://isbmuniversity.edu.in/course-details/${course.name}`;

    // Remove old schema
    // const oldSchema = document.getElementById("course-schema");

    // if (oldSchema) {
    //   oldSchema.remove();
    // }

    // Add schema in HEAD
    // if (course.schema) {
    //   const script = document.createElement("script");
    //   script.type = "application/ld+json";
    //   script.id = "course-schema";

    //   const cleanSchema = course.schema
    //     .replace(/<script[^>]*>/gi, "")
    //     .replace(/<\/script>/gi, "")
    //     .trim();

    //   script.text = cleanSchema;

    //   document.head.appendChild(script);
    // }

    // return () => {
    //   const schema = document.getElementById("course-schema");

    //   if (schema) schema.remove();
    // };

    if (course?.schema?.trim()) {
      // Remove old schemas
      document
        .querySelectorAll(".dynamic-course-schema")
        .forEach((el) => el.remove());

      const parser = new DOMParser();
      const doc = parser.parseFromString(course.schema, "text/html");

      const scripts = doc.querySelectorAll(
        'script[type="application/ld+json"]',
      );

      scripts.forEach((schemaScript, index) => {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.className = "dynamic-course-schema";
        script.id = `course-schema-${index}`;

        script.text = schemaScript.textContent.trim();

        document.head.appendChild(script);
      });
    }

    return () => {
      document
        .querySelectorAll(".dynamic-course-schema")
        .forEach((el) => el.remove());
    };
  }, [course]);

  // Parse specializations
  const parseSpecializationData = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html || "";

    return {
      description: Array.from(tempDiv.querySelectorAll("p"))
        .map((p) => p.outerHTML)
        .join(""),
      items: Array.from(tempDiv.querySelectorAll("li")),
    };
  };

  const specializationData = course?.specialization
    ? parseSpecializationData(course.specialization)
    : { description: "", items: [] };

  const formatTitle = (text) => {
    if (!text) return "";

    return text
      .replace(/-/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const higherStudies = course?.higher_studies
    ? JSON.parse(course.higher_studies)
    : [];

  const faqs = course?.faq_content ? JSON.parse(course.faq_content) : [];

  // RETURNS AFTER ALL HOOKS
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    course && (
      <React.Fragment>
        <Topnav />
        {/* page content */}
        <div
          className={`innerbackimage position-relative section-hero-banner ${course.banner}`}
          aria-label="Best University in Chhattisgarh"
        >
          <div class="bannerShape">
            <div class="bannerDetails" id="bannerDetails">
              <ol className="breadcrumb mt-3 mb-3 justify-content-start">
                <li className="breadcrumb-item">
                  <Link to="/" className="text-white text-decoration-none">
                    Home
                  </Link>
                </li>

                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  <Link
                    to={`/school-details/${course.school_name
                      .toLowerCase()
                      .replace(/&/g, "and")
                      .replace(/\s+/g, "-")}`}
                    className="text-white text-decoration-none"
                  >
                    {formatTitle(course.school_name)}
                  </Link>
                </li>

                <li
                  className="breadcrumb-item active text-white fw-bold"
                  aria-current="page"
                >
                  {course.short_title
                    ? `${course.short_title} Course`
                    : course.title}
                </li>
              </ol>
              <h1 class="fw-bold text-white mb-3">
                {" "}
                {course.level === "Undergraduate"
                  ? `${course.title} `
                  : course.title}
              </h1>
              <div
                class="text-white small"
                dangerouslySetInnerHTML={{
                  __html: course.banner_description,
                }}
              ></div>
              <div className="row mx-0 mb-3">
                <Row className="info-line w-auto">
                  <i class="ti ti-file-spark me-2 align-self-center"></i>
                  <p className="text-white">{course.level}</p>
                </Row>
                <Row className="info-line w-auto">
                  <i class="ti ti-file-report me-2 align-self-center"></i>
                  <p className="text-white">{course.duration}</p>
                </Row>
                <Row className="info-line w-auto">
                  <i class="ti ti-file-text-shield me-2 align-self-center col-auto"></i>
                  <p className="text-white col-11">{course.eligibility}</p>
                </Row>
              </div>
              <div class="d-flex">
                <button
                  type="button"
                  class="btn btn-apply me-2"
                  onClick={() => setModalShow(true)}
                >
                  Apply Now
                </button>
                <EnquiryNow
                  show={modalShow}
                  onHide={() => setModalShow(false)}
                />
                <a
                  onClick={(e) => {
                    e.preventDefault(); // stop auto-download
                    setModalShow(true); // open modal instead
                  }}
                  className="btn btn-download"
                  href={Brochure} // keep reference
                  target="_blank"
                  download="ISBM_PROSPECTUS.pdf"
                >
                  Download Brochure
                </a>
              </div>
            </div>
          </div>
        </div>

        <section className="ptb-50 text-center">
          <div className="container-xxl">
            <div className="text-center mb-5">
              <h2 className="text-blue section-title modern-title">
                {course.short_title
                  ? `${course.short_title} Degree Overview`
                  : "Overview"}
              </h2>
            </div>
            <div
              class="overview"
              dangerouslySetInnerHTML={{
                __html: course.description,
              }}
            ></div>
          </div>
        </section>

        <section class="py-5 bg-purple text-white text-center">
          <h2>Transform Your Tomorrow</h2>
          <p class="w-50 m-auto text-center my-4">
            Unlock endless possibilities and shape your future today. Transform
            your tomorrow with the education that empowers you to achieve
            greatness.
          </p>
          <button
            type="button"
            class="btn btn-sm btn-download px-5 me-2"
            onClick={() => setModalShow2(true)}
          >
            Apply Now
          </button>
          <EnquiryNow show={modalShow2} onHide={() => setModalShow2(false)} />
        </section>

        {/* {specializationItems.length > 0 && (
          <section className="course-specializations ptb=100">
            <div className="container-xxl">
              <div id="specializations" className="specializations py-5">
                <h2 className="text-blue text-center section-title modern-title">
                  {course.short_title && course.level === "Undergraduate"
                    ? `Specializations in ${course.short_title} Degree`
                    : "Specializations Offered"}
                </h2>
                <h4 className="text-center mb-3">
                  {course.specialization_selection}
                </h4>
                <ul className="row mt-4">
                  {Array.from(specializationItems).map((item, index) => (
                    <li key={index} className="col-lg-4 col-md-4 col-sm-12">
                      {item.textContent}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </section>
        )} */}

        {course?.specialization && (
          <section className="course-specializations ptb-100">
            <div className="container-xxl">
              <div id="specializations" className="specializations py-5">
                <h2 className="text-blue text-center section-title modern-title">
                  {course.short_title
                    ? `Specializations in ${course.short_title} Degree`
                    : "Specializations Offered"}
                </h2>

                <h4 className="text-center mb-3">
                  {course.specialization_selection}
                </h4>

                {/* Description */}
                {specializationData.description && (
                  <div
                    className="specialization-description mt-4"
                    dangerouslySetInnerHTML={{
                      __html: specializationData.description,
                    }}
                  />
                )}

                {/* List */}
                {specializationData.items.length > 0 && (
                  <ul className="row mt-4 p-0">
                    {specializationData.items.map((item, index) => (
                      <li key={index} className="col-lg-4 col-md-4 col-sm-12">
                        {item.textContent}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </section>
        )}

        <section className="ptb-50 color-section">
          <div className="container-xxl">
            <div className="text-center mb-5">
              <h2 className="text-blue section-title modern-title">
                {course.short_title 
                  ? `${course.short_title} Degree Course Outcome`
                  : "Course Outcomes"}
              </h2>
            </div>
            <div
              class="overview"
              dangerouslySetInnerHTML={{
                __html: course.outcome,
              }}
            ></div>
          </div>
        </section>

        <section className="container py-5">
          <div className="coList row mx-0 mt-30">
            <div className="col-lg-5 col-12">
              <div className="coCol1">
                <figure>
                  <h2 className="black_title">
                    {course.short_title 
                      ? `Career Opportunities with ${course.short_title} Degree `
                      : "Career Opportunities"}
                  </h2>
                  <figcaption className="blockquote-footer mt-2 mb-4">
                    Uncover the findings from your studies
                  </figcaption>
                </figure>
                <p>
                  Explore a world of career opportunities that align with your
                  passions. Unlock doors to success with the right skills and
                  guidance.
                </p>
              </div>
            </div>
            <div className="col-lg-7 col-12">
              <h3 className="text-blue text-center section-title modern-title">
                {course.short_title 
                  ? `Job Roles After ${course.short_title} Degree`
                  : "Future-Ready Opportunities"}
              </h3>
              <ul className="row mt-4">
                {careerList && careerList.length > 0 ? (
                  careerList.map((careers) => (
                    <li className="col-lg-6 col-md-6 col-12 p-2" key={careers}>
                      <div className="coListLi">{careers}</div>
                    </li>
                  ))
                ) : (
                  <li>No career opportunities available</li>
                )}
              </ul>
            </div>
          </div>
        </section>
        {/* new sections */}
        {higherStudies && higherStudies.length > 0 && (
          <section className="py-5 bg-light">
            <div className="container-xxl">
              <div className="text-center mb-5">
                <h2 className="text-blue section-title modern-title">
                  {course.short_title
                    ? `Higher Studies After ${course.short_title} Degree`
                    : "Higher Studies"}
                </h2>
              </div>

              {higherStudies[0]?.description && (
                <div
                  className="overview text-center mb-5"
                  dangerouslySetInnerHTML={{
                    __html: higherStudies[0].description,
                  }}
                />
              )}

              {higherStudies.length > 1 && (
                <div className="row g-4">
                  {higherStudies.slice(1).map((item, index) => (
                    <div className="col-lg-4 col-md-6" key={index}>
                      <div className="card h-100 border-0 shadow-sm rounded-4">
                        <div className="card-body p-4">
                          <h4 className="fw-bold text-blue mb-3">
                            {item.title}
                          </h4>

                          <p>{item.description}</p>

                          {item.link && (
                            <Link to={item.link} className="btn btn-download">
                              Explore Program
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </section>
        )}

        {faqs && faqs.length > 0 && (
          <section className="py-5">
            <div className="container-xxl">
              <div className="text-center mb-5">
                <h2 className="text-blue section-title modern-title">
                  {course.short_title
                    ? `FAQs About ${course.short_title} Degree`
                    : "Frequently Asked Questions"}
                </h2>
              </div>

              <div className="accordion" id="faqAccordion">
                {faqs.map((faq, index) => (
                  <div
                    className="accordion-item mb-3 border rounded-4 overflow-hidden"
                    key={index}
                  >
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${
                          index !== 0 ? "collapsed" : ""
                        }`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#faq${index}`}
                      >
                        {faq.question}
                      </button>
                    </h2>

                    <div
                      id={`faq${index}`}
                      className={`accordion-collapse collapse ${
                        index === 0 ? "show" : ""
                      }`}
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body"><div dangerouslySetInnerHTML={{ __html: faq.answer }} /></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        <Allinone />
        <Footer />
        <Modal
          show={show}
          onHide={handleClose}
          centered
          className="video_courses_abcdsa"
        >
          <Modal.Body className="p-0 bg-transparent">
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/jgS_lbVI428"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    )
  );
};

export default CourseDetails;
